import { useState } from "react"
import { Button } from "../../../ui/buttons/Button"

/**
 * Dialog for supervisor (or higher permissions) to pause or unpause notifications, as well as send message about run
 * 
 * @param {number} selectedRun
 * @param {Function} setShowModal
 * @param {Boolean} isPaused
 * @param {Function} handleSubmit
 * 
 * @returns {JSX.Element}
 * 
 * @todo possible future task: have checkbox for supervisor to decide whether to send messages to users devices
 */
export const PauseNotificationsDialog = ({selectedRun, setShowModal, isPaused, handleSubmit}) => {
    const [message, setMessage] = useState("")

    return (
        <MessageDialog
            handleSubmit={() => {
                handleSubmit(message, selectedRun, isPaused, setShowModal)
            }}
            title={`${isPaused ? "Unpause Notifications" : "Pause Notifications"} and Send Message`}
            submitButtonText={`${isPaused ? "Unpause ": "Pause"}  and Send Message`}
            setShowModal={setShowModal}
            message={message}
            setMessage={setMessage} 
        />
    )
}

/**
 * Dialog to send message about run - does not pause or unpause notifications
 * 
 * @param {number} selectedRun
 * @param {Function} setShowModal
 * 
 * @returns {JSX.Element}
 * 
 * @todo possible future task: have checkbox for supervisor to decide whether to send messages to users devices
 */
export const NotificationsMessageDialog = ({selectedRun, setShowModal, handleSubmit}) => {
    const [message, setMessage] = useState("")


    return (
        <MessageDialog
            handleSubmit={() => {
                handleSubmit(message, selectedRun)
                setShowModal(false)
            }}
            title="Send Message"
            submitButtonText="Send Message"
            setShowModal={setShowModal}
            message={message}
            setMessage={setMessage} 
        />
    )
}

const MessageDialog = ({
    handleSubmit,
    title,
    submitButtonText,
    setShowModal,
    message,
    setMessage
}) => {
    return(
        <div>
            <h1 className="font-semibold mb-6">{title}</h1>

            {/* future task: let supervisor choose if they want to send messages to users' email */}
            {/* <div>
                <div className="flex gap-3 my-5">
                    <Checkbox
                        name='send-to-devices-checkbox'
                    />
                    <Label
                        forId="send-to-devices-checkbox"
                    >
                        Send Message To User's Devices
                    </Label>
                </div>
            </div> */}

            <p className={`text-sm ${title.includes("Unpause Notifications") ? 'mb-4' : 'mb-6'}`}>
                <i className="fa-solid fa-circle-exclamation mr-2 text-yellow-500" ></i>
                This message will be sent to everyone who is subscribed to notifications for this run.
            </p>

            {/* warn user that they'll get a more accurate speed and notifications if they have more passtimes to create a new average speed - assuming pig was stuck for a long time and they had to pause notifications for a while */}
            {title.includes("Unpause Notifications") && (
                <p className="text-sm mb-6 text-red-600">
                    <i className="fa-solid fa-circle-exclamation mr-2 text-red-500" ></i>
                    Important: Only unpause notifications after entering at least 2 new pass times. This ensures more accurate speed, estimated pass times, and notifications.
                </p>
            )}

            <div className="w-full">
                <textarea
                    placeholder="Enter your message..."
                    className="border border-gray-300 rounded-lg px-4 py-2 w-full h-32 resize-y"
                    onChange={(e) => setMessage(e.target.value)}
                    value={message}
                >

                </textarea>
            </div>
            <div className="flex justify-around mt-10">
                <Button
                    onClick={handleSubmit}
                    className="mr-2"
                >
                    {submitButtonText}
                </Button>
                <Button
                    variant="danger"
                    onClick={() => setShowModal(false)}
                >
                    Cancel
                </Button>
            </div>
        </div>
    )
}